export const getters = {
  filesCount: (state) => state.uploadedFiles.length,
  filteredFiles: (state) => {
    const uniquePaths = [];
    // only take the unique items from the available uploaded files
    let uploadedFiles = state.uploadedFiles.filter((file) =>
      uniquePaths.includes(file.FilePath) ? false : uniquePaths.push(file.FilePath)
    );
    switch (state.importTabIndex) {
      case 1:
        uploadedFiles = uploadedFiles.filter(
          (file) => ['Todo', 'Processing', 'Error', 'Completed', 'Terminated'].indexOf(file.Status) < 0
        );
        break;
      case 2:
        uploadedFiles = uploadedFiles.filter((file) => ['Todo', 'Processing'].indexOf(file.Status) > -1);
        break;
      case 3:
        uploadedFiles = uploadedFiles.filter((file) => file.Status === 'Error');
        break;
      case 4:
        uploadedFiles = uploadedFiles.filter((file) => ['Terminated', 'Completed'].indexOf(file.Status) > -1);
        break;
    }
    return uploadedFiles;
  }
};
